module.exports = __webpack_public_path__ + "static/media/world-map.3c77c7e4.png";